<template>
<div>
<div class="d-print-none d-block">
  <div class="row">
    <div class="col">
      <div
        class="container-fluid col-md-11"
        style="
          background: rgb(248, 249, 250);
          border-radius: 10px;
          box-shadow: 5px 5px 5px 5px #999999;
        "
        id="contenedor"
      >
       <u @click="irMenu()">
				<br><h6>Volver</h6>
            </u>
      <div class="d-flex justify-content-center">
							<div class="row">
								<div class="col">
								<br>
								<img src="https://seguimiento.cmimbral.cl/assets/logo_tienda.png"  width="200" class="img-fluid" alt="Responsive image"><br>
								</div>
							</div>
							
                        </div><br>
            <h3 class="text-center"><b>Resumen</b></h3><br>
    
        
							<div id="bVendedor" >
							<div class="row">
							<div class="col-sm-3">
                                <div class="form-group">
                                    <label for="sucursal" ><strong>Sucursal</strong></label>
                                    <select class="form-select" v-model="sucursalElegida" id="sucursal" aria-label="Default select example"  style="border-color: rgb(237, 126, 37);">
                                      <option value="Caja CC">Caja Centro Comercial</option>    
                                      <option value="Centro Comercial">RRHH Centro Comercial </option>
                                        <option value="Transportes">Transportes</option>
                                        
                                      
                                    
                                    </select>
                                </div>
                            </div>
                            <div class="col-sm-2">
                                <div class="form-group">
                                    <label for="tipoPago" ><strong>Tipo</strong></label>
                                    <select class="form-select" id="tipoVale" aria-label="Default select example"  style="border-color: rgb(237, 126, 37);">
									<option value="Gas">Gas</option>
                                    <option value="Productos">Productos</option>
                                    </select>
                                </div>
                            </div>
                            <div class="col-sm-2">
                                <div class="form-group">
                                    <label for="tipoPago" ><strong>Tipo Pago</strong></label>
                                    <select class="form-select" id="tipoPago" aria-label="Default select example"  style="border-color: rgb(237, 126, 37);">
									<option value="Desc. Planilla">Desc. Planilla</option>
                                    <option value="Pago por Caja">Pago por Caja</option>
                                    <option value="Todos">Todos</option>
                                    </select>
                                </div>
                            </div>
							<div class="col-sm-2">
								<label ><strong>Fecha desde</strong></label><br>
								<input type="date" class="form-control" id="fecha1v" style=" border: solid 1px; border-radius: 5px;border-color:rgb(237,126,37) "/>
								
							</div>
                            <div class="col-sm-2">
								<label ><strong>Fecha hasta</strong></label><br>
								<input type="date" class="form-control" id="fecha2v" style=" border: solid 1px; border-radius: 5px; border-color:rgb(237,126,37)"/>
                            </div>
								
								<div class="col-sm"><label for="btnBuscar" ><strong>Buscar</strong></label><br>
										<button type="submit"  id="btnBuscar" class="btn btn-primary" @click="buscarTipoPago()"  style="background-color:rgb(0,56,143); border-color:rgb(237,126,37)"><i class="fas fa-search"></i></button>
								</div>
                        </div><br><br>
							
						</div>	

           
  
  

        <table class="table table-striped table-responsive" style="display:block">
           <thead style="background-color:rgb(0,58,140);color:white">
            <tr>
              <th>PRODUCTO</th>
              <th>CANTIDAD</th>
              <th>PRECIO</th>
              <th>TOTAL</th>
              <th>COLABORADOR</th>
              <th>FECHA</th>
              <th>TIPO PAGO</th>
              <th>USUARIO</th>
              <th>COMPROBANTE</th>
              
            
              
            </tr>
          </thead>
          <tbody>
            <tr v-for="x in Vales" :key="x.key">
              <td>{{ x.producto}}</td>
              <td>{{ x.cantidad}}</td>
              <td>{{ x.precio }}</td>
              <td>{{ x.total }}</td>
              <td>{{ x.nombre }}</td>
              <td>{{ x.fecha}} {{ x.hora}}</td>
              <td>{{ x.metodoPago }}</td>
              <td>{{ x.usuario }}</td>
              <td v-if="x.comprobante!=null && x.comprobante!='no'">
                <button
                  type="button"
                  @click="verArchivo(x.comprobante)"
                  class="btn btn-success btn-sm"
                  style="
                    background-color: rgb(0, 56, 143);
                    color: white;
                    border-color: rgb(237, 126, 37);
                  "
                >
                 <i class="far fa-image fa-2x"></i>
                </button>
              </td>
              <td v-else>
                <h6 style="color:#ED7E25"><b>NO</b> </h6>
              </td>
              
            </tr>
          </tbody>
        </table>
        <h5>Vales entregados por el usuario: {{largoUsuario}} / Vales totales: {{largo}}</h5>
        
        <h5>Total Desc. Planilla $: {{sumaTotalPlanilla}} / {{largoPlanilla}}</h5>
        <h5>Total Pago por Caja $: {{sumaTotalPago}} / {{largoPago}}</h5>
        
        <br>
        <div class="d-flex justify-content-center">
                    <div class="form-group">
                        <button class="btn btn-success btn-block" @click="imprimir()" >Imprimir Resumen</button><br><br>
                    </div>
                </div>
<br>
        <iframe id="pdf" width="100%" height="800px"></iframe>
      </div>
    </div>
    <div>
    
  <b-modal id="modal-1" hide-footer hide-header >
    
    <div class="d-block text-center">
      <h3><b>Editar Cheque</b></h3><br>
      
                <input type="text" id="key" v-model="key" class="form-control" placeholder="Ingrese RUT facturación" style="display:none"  >
                         
                <div class="row">
                
                    <div class="col-sm-6">
                        <div class="form-group">
                        <label>RUT facturación</label>
                        <input type="text" id="rutF" v-model="rutFacturacion" class="form-control" placeholder="Ingrese RUT facturación" style="border-color:rgb(237,126,37)"   required>
                         </div>
                    </div>
                    <div class="col-sm-6">
                        <div class="form-group">
                        <label>N° documento</label>
                        <input type="text" id="nDoc" v-model="documento" class="form-control" placeholder="Ingrese n° documento" style="border-color:rgb(237,126,37)"  required>
                        </div>
                    </div>
                    
                    
                </div><br>
                
                <div class="row">
                    <div class="col-sm-6">
                        <div class="form-group">
                        <label>RUT titular</label>
                        <input type="text" id="rutT" v-model="rut" class="form-control" placeholder="Ingrese RUT" style="border-color:rgb(237,126,37)" required>
                        </div>
                    </div>
                    <div class="col-sm-6">
                        <div class="form-group">
                        <label>Nombre titular</label>
                        <input type="text" id="nombreT" v-model="nombreTitular" class="form-control" placeholder="Ingrese nombre" style="border-color:rgb(237,126,37)"  required>
                        </div>
                    </div>
                   
                </div><br>
                <div class="row">
                    <div class="col-sm-6">
                        <div class="form-group">
                        <label>Razón social</label>
                        <input type="text" id="razonS" v-model="razonSocial" class="form-control" placeholder="Ingrese nombre" style="border-color:rgb(237,126,37)"  required>
                        </div>
                    </div>
                    <div class="col-sm-6">
                        <label>Monto del cheque</label>
                            <div class="input-group mb-3">
                            <div class="input-group-prepend">
                                <span class="input-group-text" style="border-color:rgb(237,126,37)">$</span>
                            </div>
                           <input type="text" id="monto" v-model="monto" class="form-control" placeholder="Ingrese monto" style="border-color:rgb(237,126,37)"  required>
                        
                            </div>
                    </div>
                </div><br>
                <div class="row">
                    <div class="form-group">
                        <label for="observacion">Observacion</label>
                        <textarea class="form-control" id="observacion" v-model="observacion" rows="3"  style="border-color:rgb(237,126,37)"></textarea><br>
                    </div>
                </div>
               <!-- <div class="row" >
                    <div class="col-sm-6">
                        <input style="border-color:rgb(237,126,37)" @change="clickImagen($event)" type="file" accept="image/*" >
                    </div>

                </div>--><br>

                
                <div class="d-flex justify-content-center">
                    <div class="form-group">
                        <button class="btn btn-primary btn-block" @click="editar()" style="background-color: rgb(0, 56, 143); color: white; border-color: rgb(237, 126, 37);">Editar</button><br><br>
                    </div>
                </div>

    </div>

  </b-modal>
</div>
  </div>
  </div>
 
  <div class="d-print-block d-none"><br>
   <div class="row">
    <div class="col"><br>
       <h5 class="text-center"><b>Resumen Entrega de Vales {{sucursalElegida}}</b></h5>
    </div>
  </div>
    <div class="row">
      <div class="col">
        <table class="table table-striped table-responsive" style="display:block">
           <thead style="background-color:rgb(0,58,140);color:white">
            <tr>
              <th>PRODUCTO</th>
              <th>CANTIDAD</th>
              <th>PRECIO</th>
              <th>TOTAL</th>
              <th>COLABORADOR</th>
              <th>FECHA</th>
              <th>TIPO PAGO</th>
              <th>USUARIO</th>
              
            
              
            </tr>
          </thead>
          <tbody>
            <tr v-for="x in Vales" :key="x.key">
              <td>{{ x.producto}}</td>
              <td>{{ x.cantidad}}</td>
              <td>{{ x.precio }}</td>
              <td>{{ x.total }}</td>
              <td>{{ x.nombre }}</td>
              <td>{{ x.fecha}} {{ x.hora}}</td>
              <td>{{ x.metodoPago }}</td>
              <td>{{ x.usuario }}</td>
              
              
            </tr>
          </tbody>
        </table>
         <div class="d-flex justify-content-center">
                    <div class="row">
                      <div class="col">
                       <h5>Vales entregados por el usuario: {{largoUsuario}} / Vales totales: {{largo}}</h5>
                      </div>
                    </div>
                    </div>
        <div class="d-flex justify-content-center">
                    <div class="row">
                      <div class="col">
                        <h5>Total Desc. Planilla $: {{sumaTotalPlanilla}} / {{largoPlanilla}}</h5>
                      </div>
                    </div></div>
                    <div class="d-flex justify-content-center"> 
                    <div class="row">
                      <div class="col">
                        <h5>Total Pago por Caja $: {{sumaTotalPago}} / {{largoPago}}</h5>
                      </div>
                    </div></div>
                     
                   
                
      </div>
    </div>
  </div>
</div>
</template>

<script>
import { db } from "../firebaseDb";
import { storage } from "../firebaseDb";
import Swal from "sweetalert2";
import Vue from 'vue'
    import { BootstrapVue } from 'bootstrap-vue'
    Vue.use(BootstrapVue)
const ref = storage.ref();

export default {
  data() {
    return {
      Transacciones: [],
      vendedores:[],
      editado:[],
      chequeEditado:[],
      observacion:'',
      key:'',
      rutFacturacion:'',
      documento:'',
      rut:'',
      nombreTitular:'',
      razonSocial:'',
      monto:'',
      usuario:'',
      largo:0,
      Vales:[],
      sumaTotalPlanilla:0,
      sumaTotalPago:0,
      sucursalElegida:'Centro Comercial',
      largoUsuario:0,
      largoPlanilla:0,
      largoPago:0,
    };
  },
  created() {
    document.getElementById("nav").style.display="block";
    this.usuario=localStorage.nombreUsuario;
    this.validarUsuario();
   
    
  },
  methods: {

    imprimir(){
      window.print()
    },
    irMenu(){
                if(localStorage.tipoUsuario=="1"){
                    this.$router.push('/menu')
                }else if(localStorage.tipoUsuario=="2" || localStorage.tipoUsuario=="3"){
                    this.$router.push('/menutransportes')
                }
            },
    verArchivo(imagen) {
      console.log(imagen);
      document.getElementById("pdf").src = "";
      console.log(imagen);
      const refImg = ref
        .child("comprobantes/" + imagen)
        .getDownloadURL()
        .then(function (url) {
          console.log(refImg);

          var img = document.getElementById("pdf");
          img.src = url;
        })
        .catch(function (error) {
          console.log(error);
          Swal.fire({
            title: "Error",
            text: "No hay imagen asociada",
            icon: "error",
          });
        });
    },
   
    buscarTipoPago(){
       this.largo=0;
       this.largoUsuario=0,
       this.sumaTotal=0;
       this.sumaTotalPlanilla=0;
       this.sumaTotalPago=0;
       this.largoPlanilla=0;
       this.largoPago=0;
       var sucursal= document.getElementById("sucursal").value;
       var tipoPago= document.getElementById("tipoPago").value;
       var fecha1= document.getElementById("fecha1v").value;
       var fecha2= document.getElementById("fecha2v").value;
       var tipoVale= document.getElementById("tipoVale").value;
       
                var fecha12=fecha1.split("-");
                var año=fecha12[0]
                var mes=fecha12[1]
                var dia=fecha12[2]
                var fechaF1=año+mes+dia

                var fecha22=fecha2.split("-");
                var año2=fecha22[0]
                var mes2=fecha22[1]
                var dia2=fecha22[2]
                var fechaF2=año2+mes2+dia2
                console.log()
        if(tipoVale=="Gas"){
          if(tipoPago!="Todos"){
            db.collection('vale').where("fr", ">=", fechaF1).where("fr", "<=", fechaF2).where("metodoPago", "==", tipoPago).where("sucursalEntrega", "==", sucursal).orderBy("fr","desc").orderBy("hora","desc").onSnapshot((snapshotChange) => {
                this.Vales = [];
                if(snapshotChange.empty){
                  Swal.fire({
                      title: "Error",
                      text: "No se encontraron vales",
                      icon: "error",
                    });
                }else{
                    //this.largo=(snapshotChange.docs.length)
                    snapshotChange.forEach((doc) => {
                      //console.log(doc.data().tipo)
                          if(doc.data().tipo==undefined){
                                this.largo=parseInt(this.largo)+parseInt(doc.data().cantidad)
                              if(doc.data().usuario==this.usuario){
                              var imagen=(doc.data().imagen?doc.data().imagen:"no")
                              if(doc.data().metodoPago=="Desc. Planilla"){
                              this.sumaTotalPlanilla=parseInt(this.sumaTotalPlanilla)+parseInt(doc.data().total)
                              this.largoPlanilla=parseInt(this.largoPlanilla)+parseInt(1)
                              }else{
                                this.sumaTotalPago=parseInt(this.sumaTotalPago)+parseInt(doc.data().total)
                                this.largoPago=parseInt(this.largoPago)+parseInt(1)
                              }
                              this.Vales.push({
                                key: doc.id,
                                producto: doc.data().producto,
                                cantidad: doc.data().cantidad,
                                precio: doc.data().precio,
                                total: doc.data().total,
                                rut: doc.data().rut,
                                nombre: doc.data().nombre,
                                razon: doc.data().razon,
                                observacion: doc.data().observacion, 
                                metodoPago: doc.data().metodoPago,
                                usuario: doc.data().usuario,
                                fecha: doc.data().fecha+" "+doc.data().hora,
                                comprobante:imagen
                              }) 
                              this.largoUsuario=parseInt(this.largoUsuario)+parseInt(doc.data().cantidad)
                            }
                          }
                          
                    
                    });
                }
               
          })
        }else{
            db.collection('vale').where("fr", ">=", fechaF1).where("fr", "<=", fechaF2).where("sucursalEntrega", "==", sucursal).orderBy("fr","desc").orderBy("hora","desc").onSnapshot((snapshotChange) => {
                this.Vales = [];
                if(snapshotChange.empty){
                  Swal.fire({
                      title: "Error",
                      text: "No se encontraron vales",
                      icon: "error",
                    });
                }else{
                    
                    snapshotChange.forEach((doc) => {
                     // console.log(doc.data().tipo)
                          if(doc.data().tipo==undefined){
                              this.largo=parseInt(this.largo)+parseInt(doc.data().cantidad)
                              if(doc.data().usuario==this.usuario){
                              var imagen=(doc.data().imagen?doc.data().imagen:"no")
                              if(doc.data().metodoPago=="Desc. Planilla"){
                              this.sumaTotalPlanilla=parseInt(this.sumaTotalPlanilla)+parseInt(doc.data().total)
                              this.largoPlanilla=parseInt(this.largoPlanilla)+parseInt(doc.data().cantidad)
                              }else{
                                this.sumaTotalPago=parseInt(this.sumaTotalPago)+parseInt(doc.data().total)
                                this.largoPago=parseInt(this.largoPago)+parseInt(doc.data().cantidad)
                              }
                              this.Vales.push({
                                key: doc.id,
                                producto: doc.data().producto,
                                cantidad: doc.data().cantidad,
                                precio: doc.data().precio,
                                total: doc.data().total,
                                rut: doc.data().rut,
                                nombre: doc.data().nombre,
                                razon: doc.data().razon,
                                observacion: doc.data().observacion, 
                                metodoPago: doc.data().metodoPago,
                                usuario: doc.data().usuario,
                                fecha: doc.data().fecha+" "+doc.data().hora,
                                comprobante:imagen
                              }) 
                              this.largoUsuario=parseInt(this.largoUsuario)+parseInt(doc.data().cantidad)
                            }

                          }
                          
                    
                    });
                }
               
          })
          }   
          
          



        }else{

          
            if(tipoPago!="Todos"){
            db.collection('vale').where("fr", ">=", fechaF1).where("fr", "<=", fechaF2).where("metodoPago", "==", tipoPago).where("sucursalEntrega", "==", sucursal).orderBy("fr","desc").orderBy("hora","desc").onSnapshot((snapshotChange) => {
                this.Vales = [];
                if(snapshotChange.empty){
                  Swal.fire({
                      title: "Error",
                      text: "No se encontraron vales",
                      icon: "error",
                    });
                }else{
                    //this.largo=(snapshotChange.docs.length)
                    snapshotChange.forEach((doc) => {
                      //console.log(doc.data().tipo)
                          if(doc.data().tipo=="PRODUCTO"){
                                this.largo=parseInt(this.largo)+parseInt(doc.data().cantidad)
                              if(doc.data().usuario==this.usuario){
                              var imagen=(doc.data().imagen?doc.data().imagen:"no")
                              if(doc.data().metodoPago=="Desc. Planilla"){
                              this.sumaTotalPlanilla=parseInt(this.sumaTotalPlanilla)+parseInt(doc.data().total)
                              this.largoPlanilla=parseInt(this.largoPlanilla)+parseInt(1)
                              }else{
                                this.sumaTotalPago=parseInt(this.sumaTotalPago)+parseInt(doc.data().total)
                                this.largoPago=parseInt(this.largoPago)+parseInt(1)
                              }
                              this.Vales.push({
                                key: doc.id,
                                producto: doc.data().producto,
                                cantidad: doc.data().cantidad,
                                precio: doc.data().precio,
                                total: doc.data().total,
                                rut: doc.data().rut,
                                nombre: doc.data().nombre,
                                razon: doc.data().razon,
                                observacion: doc.data().observacion, 
                                metodoPago: doc.data().metodoPago,
                                usuario: doc.data().usuario,
                                fecha: doc.data().fecha+" "+doc.data().hora,
                                comprobante:imagen
                              }) 
                              this.largoUsuario=parseInt(this.largoUsuario)+parseInt(doc.data().cantidad)
                            }
                          }
                          
                    
                    });
                }
               
          })
        }else{
            db.collection('vale').where("fr", ">=", fechaF1).where("fr", "<=", fechaF2).where("sucursalEntrega", "==", sucursal).orderBy("fr","desc").orderBy("hora","desc").onSnapshot((snapshotChange) => {
                this.Vales = [];
                if(snapshotChange.empty){
                  Swal.fire({
                      title: "Error",
                      text: "No se encontraron vales",
                      icon: "error",
                    });
                }else{
                    
                    snapshotChange.forEach((doc) => {
                     // console.log(doc.data().tipo)
                          if(doc.data().tipo=="PRODUCTO"){
                              this.largo=parseInt(this.largo)+parseInt(doc.data().cantidad)
                              if(doc.data().usuario==this.usuario){
                              var imagen=(doc.data().imagen?doc.data().imagen:"no")
                              if(doc.data().metodoPago=="Desc. Planilla"){
                              this.sumaTotalPlanilla=parseInt(this.sumaTotalPlanilla)+parseInt(doc.data().total)
                              this.largoPlanilla=parseInt(this.largoPlanilla)+parseInt(doc.data().cantidad)
                              }else{
                                this.sumaTotalPago=parseInt(this.sumaTotalPago)+parseInt(doc.data().total)
                                this.largoPago=parseInt(this.largoPago)+parseInt(doc.data().cantidad)
                              }
                              this.Vales.push({
                                key: doc.id,
                                producto: doc.data().producto,
                                cantidad: doc.data().cantidad,
                                precio: doc.data().precio,
                                total: doc.data().total,
                                rut: doc.data().rut,
                                nombre: doc.data().nombre,
                                razon: doc.data().razon,
                                observacion: doc.data().observacion, 
                                metodoPago: doc.data().metodoPago,
                                usuario: doc.data().usuario,
                                fecha: doc.data().fecha+" "+doc.data().hora,
                                comprobante:imagen
                              }) 
                              this.largoUsuario=parseInt(this.largoUsuario)+parseInt(doc.data().cantidad)
                            }

                          }
                          
                    
                    });
                }
               
          })
          }   

        }
        
            
        
    },
    buscarRut(){
       var rut= document.getElementById("rut").value.toUpperCase().replaceAll(".","");
       var fecha1= document.getElementById("fecha1RUT").value;
       var fecha2= document.getElementById("fecha2RUT").value;
       
                var fecha12=fecha1.split("-");
                var año=fecha12[0]
                var mes=fecha12[1]
                var dia=fecha12[2]
                var fechaF1=año+mes+dia;

                var fecha22=fecha2.split("-");
                var año2=fecha22[0]
                var mes2=fecha22[1]
                var dia2=fecha22[2]
                var fechaF2=año2+mes2+dia2;
         db.collection('vale').where("fr", ">=", fechaF1).where("fr", "<=", fechaF2).where("rut", "==", rut).onSnapshot((snapshotChange) => {
                this.Vales = [];
                if(snapshotChange.empty){
                  Swal.fire({
                      title: "Error",
                      text: "No se encontraron vales",
                      icon: "error",
                    });
                }else{
                    this.largo=(snapshotChange.docs.length)
                    snapshotChange.forEach((doc) => {
                    this.Vales.push({
                        key: doc.id,
                        producto: doc.data().producto,
                        cantidad: doc.data().cantidad,
                        precio: doc.data().precio,
                        total: doc.data().total,
                        rut: doc.data().rut,
                        nombre: doc.data().nombre,
                        razon: doc.data().razon,
                        observacion: doc.data().observacion, 
                        metodoPago: doc.data().metodoPago,
                        usuario: doc.data().usuario,
                        fecha: doc.data().fecha+" "+doc.data().hora,
                    })
                });
                }
               
          })
    },
    
    validarUsuario(){
            if(this.usuario==undefined || this.usuario=="X"){
                this.$router.push('/')
            }
        },

    leer(){
                var rut = document.getElementById("rut").value;
				var rutx=rut.replace("-","");
				var largo=rutx.length
				//console.log(largo,largo-1)
				var rut2=rutx.slice(0,largo-1)
				var rut3=rutx.slice(largo-1)
                //console.log(rut2+"-"+rut3)
				document.getElementById("rut").value=(rut2+"-"+rut3)
				
        }
    
  },
};
</script>

<style>
.btn-primary {
  margin-right: 12px;
}
</style>